@if (visible) {

  <!-- Launcher: Nustone mark + "AI" -->
  @if (!open) {
  <div class="nuai-dock no-print" [style.bottom.px]="20 + lift" [class.nuai-aside]="coveredByPanel" [attr.aria-hidden]="coveredByPanel ? 'true' : null">
    <span class="nuai-halo"></span>
    <span class="nuai-halo second"></span>

    @if (peek) {
    <div class="nuai-peek">
      <button type="button" class="relative w-full text-left rounded-2xl bg-white border border-gray-200 shadow-xl px-4 py-3 pr-8" (click)="toggle()">
        <div class="text-sm font-bold text-gray-900">Hi{{ firstName ? ' ' + firstName : '' }}! I'm NuSI</div>
        <div class="text-xs text-gray-600 mt-0.5">Ask me about stock, prices, orders, customers - or who to call next.</div>
      </button>
      <button type="button" class="absolute top-1.5 right-1.5 h-6 w-6 rounded-full text-gray-400 hover:bg-gray-100 hover:text-gray-700 flex items-center justify-center"
        (click)="dismissPeek()" aria-label="Hide this tip">
        <mat-icon class="!text-[14px] !h-3.5 !w-3.5">close</mat-icon>
      </button>
    </div>
    }

    <button type="button" class="nuai-launcher focus:outline-none" (click)="toggle()" aria-label="Open NuSI assistant">
      <span class="nuai-core">
        <span class="nuai-disc">
          <app-nustone-mark class="relative z-[1] h-[15px] w-[15px] text-neutral-900" />
        </span>
        <span class="nuai-ai">SI</span>
      </span>
      <span class="nuai-live"></span>
    </button>

    <!-- Sparkles -->
    <svg class="nuai-spark s1" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 0c.6 6.6 5.4 11.4 12 12-6.6.6-11.4 5.4-12 12-.6-6.6-5.4-11.4-12-12C6.6 11.4 11.4 6.6 12 0z"/></svg>
    <svg class="nuai-spark s2" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 0c.6 6.6 5.4 11.4 12 12-6.6.6-11.4 5.4-12 12-.6-6.6-5.4-11.4-12-12C6.6 11.4 11.4 6.6 12 0z"/></svg>
    <svg class="nuai-spark s3" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M12 0c.6 6.6 5.4 11.4 12 12-6.6.6-11.4 5.4-12 12-.6-6.6-5.4-11.4-12-12C6.6 11.4 11.4 6.6 12 0z"/></svg>
  </div>
  }

  <!-- Panel -->
  @if (open) {
  <aside class="no-print fixed bottom-0 right-0 sm:bottom-5 sm:right-5 z-[60] w-full h-[100dvh] bg-white sm:rounded-2xl shadow-2xl ring-1 ring-black/10 flex flex-col overflow-hidden transition-[width,height] duration-200"
    [class]="wide ? 'sm:w-[760px] sm:h-[calc(100dvh-40px)]' : 'sm:w-[420px] sm:h-[660px] sm:max-h-[calc(100dvh-40px)]'"
    role="dialog" aria-label="NuSI assistant">

    <!-- Header -->
    <div class="relative px-4 pt-3.5 pb-3 bg-gradient-to-br from-neutral-900 via-neutral-900 to-neutral-800 text-white flex-shrink-0">
      <div class="flex items-center gap-3">
        <span class="nuai-head-disc h-10 w-10 rounded-xl bg-gradient-to-br from-amber-200 via-amber-400 to-amber-600 flex items-center justify-center shadow-inner flex-shrink-0">
          <app-nustone-mark class="relative z-[1] h-5 w-5 text-neutral-900" />
        </span>
        <div class="flex-1 min-w-0">
          <div class="leading-tight"><span class="nuai-ai !text-[19px]">SI</span><span class="sr-only">NuSI</span></div>
          <div class="text-[11px] text-neutral-400 leading-tight flex items-center gap-1">
            <span class="h-1.5 w-1.5 rounded-full bg-emerald-400"></span> Nustone's assistant · live shop data · read-only
          </div>
        </div>
        <button type="button" class="h-8 w-8 rounded-lg text-neutral-300 hover:bg-white/10 hover:text-white hidden sm:flex items-center justify-center"
          (click)="wide = !wide" [matTooltip]="wide ? 'Smaller' : 'Wider view'" [attr.aria-label]="wide ? 'Make smaller' : 'Make wider'">
          <mat-icon class="!text-[18px] !h-[18px] !w-[18px]">{{ wide ? 'close_fullscreen' : 'open_in_full' }}</mat-icon>
        </button>
        <button type="button" class="h-8 w-8 rounded-lg text-neutral-300 hover:bg-white/10 hover:text-white flex items-center justify-center"
          (click)="newChat()" matTooltip="New chat" aria-label="Start a new chat">
          <mat-icon class="!text-[18px] !h-[18px] !w-[18px]">edit_square</mat-icon>
        </button>
        <button type="button" class="h-8 w-8 rounded-lg text-neutral-300 hover:bg-white/10 hover:text-white flex items-center justify-center"
          (click)="toggle()" aria-label="Close NuSI">
          <mat-icon class="!text-[20px] !h-5 !w-5">close</mat-icon>
        </button>
      </div>
      @if (page.label) {
      <div class="mt-2.5 inline-flex items-center gap-1.5 rounded-full bg-white/10 px-2.5 py-1 text-[11px] text-neutral-200 max-w-full"
        matTooltip="NuSI knows which page you're on, so you can say 'this order' or 'this basket'">
        <mat-icon class="!text-[13px] !h-3.5 !w-3.5 text-amber-400">my_location</mat-icon>
        <span class="truncate">{{ page.label }}</span>
      </div>
      }
    </div>

    <!-- Messages -->
    <div #scroller class="flex-1 overflow-y-auto px-4 py-4 bg-gradient-to-b from-gray-50 to-white flex flex-col gap-4">
      @if (!messages.length) {
        <div class="flex flex-col items-center text-center pt-6 pb-2">
          <span class="h-14 w-14 rounded-2xl bg-neutral-900 flex items-center justify-center shadow-lg shadow-neutral-900/20 mb-3">
            <app-nustone-mark class="h-7 w-7 text-amber-400" />
          </span>
          <div class="text-lg font-bold text-gray-900">{{ greeting }}</div>
          <p class="text-sm text-gray-500 mt-1 max-w-[300px]">Ask me about products, stock, orders, customers, leads or sales - or get help writing to a customer.</p>
        </div>
        <div class="grid gap-2" [class]="wide ? 'grid-cols-2' : 'grid-cols-1'">
          @for (s of page.suggestions; track s) {
          <button type="button" class="group text-left text-sm px-3.5 py-2.5 rounded-xl bg-white border border-gray-200 text-gray-700 hover:border-amber-300 hover:bg-amber-50 hover:text-gray-900 transition-colors flex items-start gap-2"
            (click)="ask(s)">
            <mat-icon class="!text-[16px] !h-4 !w-4 text-amber-500 mt-0.5 flex-shrink-0">arrow_outward</mat-icon>
            <span>{{ s }}</span>
          </button>
          }
        </div>
      }

      @for (m of messages; track $index) {
        @if (m.from === 'me') {
        <div class="self-end max-w-[85%] rounded-2xl rounded-br-md bg-neutral-900 text-white px-3.5 py-2 text-sm whitespace-pre-wrap break-words shadow-sm">{{ m.text }}</div>
        } @else {
        <div class="self-start flex items-start gap-2.5 max-w-[95%]">
          <span class="h-7 w-7 rounded-lg bg-neutral-900 flex items-center justify-center flex-shrink-0 mt-0.5">
            <app-nustone-mark class="h-3.5 w-3.5 text-amber-400" />
          </span>
          <div class="min-w-0 flex-1">
            @if (m.streaming && !m.text) {
              <div class="rounded-2xl rounded-tl-md bg-white border border-gray-200 px-3.5 py-2.5 text-sm text-gray-500 flex items-center gap-2 shadow-sm">
                <span class="inline-block h-3.5 w-3.5 rounded-full border-2 border-amber-400 border-t-transparent animate-spin"></span>
                {{ status || 'Thinking' }}&hellip;
              </div>
            } @else {
              <div class="rounded-2xl rounded-tl-md px-3.5 py-2 text-sm leading-relaxed break-words border shadow-sm"
                [class]="m.error ? 'bg-red-50 border-red-200 text-red-800' : 'bg-white border-gray-200 text-gray-800'">
                <div [innerHTML]="m.html"></div>
                @if (m.streaming) { <span class="inline-block w-1.5 h-4 align-text-bottom bg-amber-500 animate-pulse rounded-sm"></span> }
              </div>
              @if (m.streaming && status) {
              <div class="mt-1 px-1 text-[11px] text-gray-500 flex items-center gap-1.5">
                <span class="inline-block h-2.5 w-2.5 rounded-full border-2 border-amber-400 border-t-transparent animate-spin"></span>{{ status }}&hellip;
              </div>
              }
              @if (!m.streaming) {
              <div class="flex items-center gap-2 mt-1 px-1 text-[11px] text-gray-400">
                @if (m.toolsUsed?.length) { <span class="truncate" matTooltip="What NuSI looked up for this answer">Checked: {{ m.toolsUsed!.join(', ') }}</span> }
                @if (m.stopped) { <span>Stopped</span> }
                @if (!m.error && m.text) {
                <button type="button" class="ml-auto flex items-center gap-0.5 hover:text-gray-700" (click)="copy(m)">
                  <mat-icon class="!text-[13px] !h-3.5 !w-3.5">{{ m.copied ? 'check' : 'content_copy' }}</mat-icon>{{ m.copied ? 'Copied' : 'Copy' }}
                </button>
                }
              </div>
              }
            }
          </div>
        </div>
        }
      }
    </div>

    <!-- Input -->
    <div class="border-t border-gray-200 p-3 bg-white flex-shrink-0">
      <div class="flex items-end gap-2 rounded-2xl border border-gray-200 bg-gray-50 focus-within:bg-white focus-within:border-amber-400 focus-within:ring-2 focus-within:ring-amber-100 p-1.5 transition-colors">
        <textarea #box rows="1" [(ngModel)]="draft" (keydown)="onKeydown($event)"
          [placeholder]="sending ? 'NuSI is answering...' : 'Ask NuSI anything about the shop...'"
          class="flex-1 resize-none max-h-32 min-h-[38px] px-2 py-2 bg-transparent outline-none text-sm"></textarea>
        @if (sending) {
        <button type="button" class="h-[38px] w-[38px] rounded-xl bg-neutral-900 text-white flex items-center justify-center hover:bg-neutral-700 flex-shrink-0"
          (click)="stop()" matTooltip="Stop" aria-label="Stop the answer">
          <mat-icon class="!text-[18px] !h-[18px] !w-[18px]">stop</mat-icon>
        </button>
        } @else {
        <button type="button" class="h-[38px] w-[38px] rounded-xl bg-gradient-to-b from-amber-400 to-amber-500 text-neutral-900 flex items-center justify-center hover:from-amber-300 hover:to-amber-400 disabled:opacity-40 disabled:cursor-not-allowed flex-shrink-0"
          (click)="send()" [disabled]="!draft.trim()" aria-label="Send">
          <mat-icon class="!text-[18px] !h-[18px] !w-[18px]">arrow_upward</mat-icon>
        </button>
        }
      </div>
      <p class="text-[10px] text-gray-400 mt-1.5 px-1 flex items-center gap-1">
        <span>Enter to send · Shift+Enter for a new line</span><span class="ml-auto">NuSI can make mistakes - check before acting</span>
      </p>
    </div>
  </aside>
  }
}
